export enum ParalistGroupCodes {
  CustomerReadinessLevel = 'customer.readinesslevel',
  TaskType = 'task.type',
  TaskStatus = 'task.status',
  SharingType = 'sharing.type',
  SharingStatus = 'sharing.status',
  ProductVisibilityStatus = 'product.visibility.status',
  ProductStatus = 'product.status',
  ProductSpecificationAttributeAttributeTypeId = 'product.specificationattribute.attributetypeid',
  ProductLocationDisplaySettings = 'product.location.displaysettings',
  ProductAvailabilityStatus = 'product.availability.status',
  ProductPriceType = 'product.price.type',
  CustomerStatus = 'customer.status',
  PicturesFileContentType = 'pictures.filecontenttype',
  PicturesFileType = 'pictures.filetype',
}
